export const SUBMIT_FAIL = 'SUBMIT_FAIL';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';

export const GET_EXCEL_DATA = 'GET_EXCEL_DATA';
export const ERROR_GET_EXCEL_DATA = 'ERROR_GET_EXCEL_DATA';